<template>

  <div class="app">
    <b-loading :active.sync="isLoading"></b-loading>
    <transition name="bounce">
      <router-view>
      </router-view>
    </transition>
  </div>

</template>

<script>

import Util from './util'

export default {

  name: 'app',
  data() {
    return {
      isLoading: false
    }
  },
  methods: {
    showSpinner() {
      this.isLoading = true
    },
    hideSpinner() {
      this.isLoading = false

    }
  },
  created: function () {

    this.axios.interceptors.request.use(
      conf => {
        this.showSpinner()
        return conf;
      },
      error => {
        this.hideSpinner()
        return Promise.reject(error);
      }
    );
    this.axios.interceptors.response.use(
      response => {
        this.hideSpinner()
        return response;
      },
      error => {

        this.hideSpinner()

        if (!error.response) {
          Util.showDialogError(this, "Error al conectarse al servidor.")
        }
        else {
          console.log(error.response)
          if (error.response.status == '401') {
            this.$dialog.alert({
              title: 'Error de sesión',
              message: 'Su sesión ha <b>expirado,</b> por favor vuelva a iniciar sesión.',
              confirmText: 'Login',
              type: 'is-danger',
              hasIcon: true,
              onConfirm: () => this.$router.push({ name: 'login' })
            })


            return
          }

        }

        return Promise.reject(error);
      }
    );


  },
}
</script>


<style lang="scss">
// Import Bulma's core
@import "~bulma/sass/utilities/_all";
// Set your colors
$primary: #009eff;
$primary-invert: findColorInvert($primary);

$info: #167df0;
$info-invert: findColorInvert($info);

$twitter: #4099FF;
$twitter-invert: findColorInvert($twitter);

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
  "white": ($white, $black),
  "black": ($black, $white),
  "light": ($light, $light-invert),
  "dark": ($dark, $dark-invert),
  "primary": ($primary, $primary-invert),
  "info": ($info, $info-invert),
  "success": ($success, $success-invert),
  "warning": ($warning, $warning-invert),
  "danger": ($danger, $danger-invert),
  "twitter": ($twitter, $twitter-invert)
);

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;
// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";


.bounce-enter-active {
  animation: bounce-in .5s;
}

.bounce-leave-active {
  animation: bounce-in .5s reverse;
}

@keyframes bounce-in {
  0% {
    transform: scale(0);
  }

  50% {
    transform: scale(1.5);
  }

  100% {
    transform: scale(1);
  }
}

.has-text-filekom {
  color: #243c68;
}
</style>



// WEBPACK FOOTER //
// src/App.vue